const API_BASE_URL = import.meta.env.VITE_API_URL || "/api"

export const uploadApi = {
  async uploadBannerImage(file) {
    const formData = new FormData()
    formData.append("image", file)

    const token = localStorage.getItem("auth_token")

    const headers = {}
    if (token) {
      headers["Authorization"] = `Bearer ${token}`
    }

    const response = await fetch(`${API_BASE_URL}/upload/banner`, {
      method: "POST",
      credentials: "include",
      headers,
      body: formData,
    })

    console.log("uploadBannerImage response", response)

    if (!response.ok) {
      const error = await response.json().catch(() => ({
        message: "Ошибка загрузки изображения",
      }))
      console.error("[uploadApi] Ошибка загрузки баннера:", error)
      throw new Error(error.message || "Ошибка загрузки")
    }

    const data = await response.json()
    return data
  },

  async deleteBannerImage(filename) {
    const token = localStorage.getItem("auth_token")

    const headers = {}
    if (token) {
      headers["Authorization"] = `Bearer ${token}`
    }

    const response = await fetch(`${API_BASE_URL}/upload/banner/${filename}`, {
      method: "DELETE",
      credentials: "include",
      headers,
    })

    if (!response.ok) {
      const error = await response.json().catch(() => ({
        message: "Ошибка удаления изображения",
      }))
      throw new Error(error.message || "Ошибка удаления")
    }

    return response.json()
  },

  async uploadIconFile(file) {
    const formData = new FormData()
    formData.append("image", file)

    const token = localStorage.getItem("auth_token")

    const headers = {}
    if (token) {
      headers["Authorization"] = `Bearer ${token}`
    }

    const response = await fetch(`${API_BASE_URL}/upload/icon-file`, {
      method: "POST",
      credentials: "include",
      headers,
      body: formData,
    })

    if (!response.ok) {
      const error = await response.json().catch(() => ({ message: "Ошибка загрузки иконки" }))
      throw new Error(error.message || "Ошибка загрузки")
    }

    const data = await response.json()
    return data
  },
}
